import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Welcome from '../components/MainPageComponents/welcome';
import Catalogo from '../components/MainPageComponents/catalogo';
import ImageSlider from '../components/MainPageComponents/imageslider';
import InsigniaProduct from '../components/MainPageComponents/insignia';
import ExclusiveBenefits from '../components/MainPageComponents/exclusivebenefits';
import OrderNow from '../components/MainPageComponents/ordernow';
import Kits from '../components/MainPageComponents/kits';
import { UserProvider, useUser } from '../Context/UserContext';
import SearchContainer from "../components/MainPageComponents/searchContainer";
import { Carousel } from '../components/MainPageComponents/Carousel';

const featuredSlides = [
    {
        title: 'Kit de puentes',
        button: 'Comprar',
        src: '/images/puentes.jpg',
        link: '/products/PD9DA3-Kit%20de%20puentes',
        objectPosition: 'center 72%',
    },
    {
        title: 'Superior ESP',
        button: 'Comprar',
        src: '/images/ESP_Caja.png',
        link: '/products/PD0003-Superior%20ESP',
        objectPosition: 'center',
    },
    {
        title: 'Arduino UNO R3',
        button: 'Comprar',
        src: '/images/R3Caja.jpg',
        link: '/products/PD0005-Arduino%20UNO%20R3',
        objectPosition: 'center 58%',
    },
    {
        title: 'Arduino UNO R4',
        button: 'Comprar',
        src: '/images/R4Caja.jpg',
        link: '/products/PD0004-Arduino%20UNO%20R4',
        objectPosition: 'center 58%',
    },
];

const Home = () => {
    return (
        <UserProvider>
            <Header />
            <Welcome
                title="¡Bienvenido a Volteon!"
                subtitle="Buscá, explorá y descubrí todo lo que hay para vos"
            />
            <SearchContainer />
            <Carousel slides={featuredSlides} heading="Productos Destacados" />
            <Catalogo />
            <InsigniaProduct
                image="/images/kits.png"
                title="Kits"
                description="Descubrí nuestros kits de componentes electrónicos: prácticos, completos y pensados para potenciar tus proyectos."
                buttonText="Ver kits"
                buttonLink="/kits"
            />

            <Kits
                title="Servicios"
                description="Fabricá tu placa PCB con calidad profesional. Descubrí Volteon Services y llevá tu diseño al siguiente nivel."
                buttonText="Ir ahora"
                image="/images/logo_Services.png"
                buttonLink="/servicios/PCB"
            />

            <InsigniaProduct
                image="/images/insignia.png"
                title="Productos Insignia"
                description="Explorá nuestra línea exclusiva de productos diseñados por Volteon: componentes y kits únicos para tus desarrollos más exigentes."
                buttonText="Ver productos"
                buttonLink="/insignia"
            />
            <ExclusiveBenefits/>
            <Footer />
        </UserProvider>
    );
};

export default Home;